import React, {useEffect, useState} from "react";
import "./UsersTable.sass"
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../TableComponents";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import TableBody from "@mui/material/TableBody";
import PropTypes from "prop-types";
import {formatPhone} from "../../../common/formater";
import {ADDRESS} from "../../../_api/client";
import CircleButton from "../../common/buttons/CircleButton";
import ButtonComponent from "../../common/buttons/ButtonComponent";
import {useNavigate} from "react-router";
import SelectTextEdit from "../../common/fields/SelectTextEdit";
import {useDispatch, useSelector} from "react-redux";
import {FAILED, IDLE, SUCCESS} from "../../../common/statuses";
import {deleteStudentFromGroup, getGroups, transferStudent} from "../../../_actions/group/groupService";
import {setEmpty} from "../../../_actions/group/groupReducer";
import {useSnackbar} from "notistack";
import DialogComponent from "../../common/dialog/DialogComponent";

export default function UsersTable({users}) {

    const [student, setStudent] = useState();
    const [studentForRemoving, setStudentForRemoving] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState();

    const {data: groups, status: groupsStatus} = useSelector(state => state.groups.getGroups)
    const {message, status: transferStatus} = useSelector(state => state.groups.transferStudent)
    const {data: currentGroup} = useSelector(state => state.groups.selected)
    const {message: deleteMessage, status: deleteStatus} = useSelector(state => state.groups.deleteStudentFromGroup)

    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar()
    const navigate = useNavigate();

    useEffect(() => {
        if (groupsStatus === IDLE) {
            dispatch(getGroups())
        }
    }, [groups, groupsStatus, dispatch])
    useEffect(() => {
        if (transferStatus === SUCCESS) {
            setSelectedGroup(null)
            setStudent(null)
            dispatch(setEmpty())

            enqueueSnackbar(message, {variant: "success"})
        }
    }, [transferStatus, dispatch])
    useEffect(() => {
        if (deleteStatus === SUCCESS) {
            setSelectedGroup(null);
            setStudentForRemoving(false);
            dispatch(setEmpty())

            enqueueSnackbar(deleteMessage, {variant: "success"})
        }
        if (deleteStatus === FAILED) {
            enqueueSnackbar(deleteMessage, {variant: "error"})
        }
    }, [deleteStatus, deleteMessage, dispatch])

    const handleTransferStudent = () => {
        const body = {
            studentId: student.id,
            groupIdFrom: currentGroup.id,
            groupIdTo: selectedGroup,
        }

        dispatch(transferStudent(body))
    }

    const handleDeleteStudent = () => {
        if (studentForRemoving && currentGroup) {
            const body = {
                studentId: studentForRemoving.id,
                groupId: currentGroup.id,
            }
            dispatch(deleteStudentFromGroup(body))
        }
    }

    const renderItem = (user) => {
        const {id, img, firstName, lastName, middleName, username, phoneNumber, balance, group, discount} = user
        let phone = formatPhone(phoneNumber)
        const fullName = `${lastName} ${firstName} ${middleName || ''}`

        const lessonCost = group.cost * (100 - discount.discount) / 100

        return (
            <StyledTableRow key={`request-${id}`}>
                <StyledTableCell component="th" scope="row">
                    <div className="user-table-avatar">
                        <img src={`${ADDRESS}/avatar/${img}`} alt={fullName}/>
                    </div>
                </StyledTableCell>
                <StyledTableCell>
                    {fullName}
                </StyledTableCell>
                <StyledTableCell sx={{width: '15em'}}>
                    <a style={{textDecoration: 'none', color: 'inherit', cursor: 'alias'}}
                       href={`mailto:${username}`}>
                        {username}
                    </a>
                </StyledTableCell>
                <StyledTableCell>
                    <a style={{textDecoration: 'none', color: 'inherit', cursor: 'alias'}}
                       href={`tel:${phone}`}>
                        {phone}
                    </a>
                </StyledTableCell>
                <StyledTableCell>
                    {(lessonCost / 100).toFixed(2)} руб
                </StyledTableCell>
                <StyledTableCell>
                    <div className={parseInt(balance) > 0 ? "user-table-balance-green" : "user-table-balance-red"}>
                        {(parseInt(balance) / 100).toFixed(2)} руб
                    </div>
                </StyledTableCell>
                <StyledTableCell sx={{width: '8em'}}>
                    <div className="user-table-button-panel">
                        <div className="user-table-button">
                            <CircleButton Icon={SocialDistanceIcon}
                                          onClick={() => setStudent(user)}/>
                        </div>
                        <div className="user-table-button">
                            <CircleButton Icon={DeleteOutlineIcon}
                                          onClick={() => setStudentForRemoving(user)}/>
                        </div>
                    </div>
                </StyledTableCell>
            </StyledTableRow>
        )
    }

    const renderTransferStudent = () => {
        if (student && groups) {
            const {firstName, lastName} = student;

            const groupItems = groups.map(group => {
                return {
                    value: group.id,
                    name: group.name
                }
            })

            const buttons = {
                accept: "Перенести",
                cancel: "Отмена",
            }

            return <DialogComponent title="Перенос ученика в группу"
                                    buttons={buttons}
                                    open={!!student}
                                    onClose={() => setStudent(null)}
                                    onAccept={() => handleTransferStudent()}>
                <div className="UsersTable-dialog-context">
                    <div><b>Ученик:</b> {`${lastName} ${firstName}`}</div>
                    <div className="UsersTable-dialog-context-select">
                        <SelectTextEdit label="Перенести в"
                                        value={selectedGroup}
                                        onChange={(e) => setSelectedGroup(e.target.value)}
                                        data={groupItems}/>
                    </div>
                </div>
            </DialogComponent>
        }
    }

    const renderRemoveUserMessage = () => {
        if (studentForRemoving) {
            const buttons = {
                accept: "Удалить",
                cancel: "Назад",
            }


            return <DialogComponent title="Удаление ученика из группы"
                                    buttons={buttons}
                                    open={!!studentForRemoving}
                                    onClose={() => setStudentForRemoving(null)}
                                    onAccept={handleDeleteStudent}
            >Вы дейтвительно хотите удалить ученика из группы?</DialogComponent>
        }
    }

    return (
        <div className="users-table-wrapper">
            <TableContainer component={Paper}>
                <Table>
                    <caption>
                        <ButtonComponent onClick={() => navigate("addStudent")}>
                            Добавить ученика
                        </ButtonComponent>
                    </caption>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell sx={{width: '3em'}}></StyledTableCell>
                            <StyledTableCell>ФИО</StyledTableCell>
                            <StyledTableCell>Почта</StyledTableCell>
                            <StyledTableCell>Телефон</StyledTableCell>
                            <StyledTableCell sx={{width: '7em'}}>Цена</StyledTableCell>
                            <StyledTableCell sx={{width: '9em'}}>Баланс</StyledTableCell>
                            <StyledTableCell></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    {users &&
                        <TableBody>
                            {[...users].sort((a, b) => {
                                const aName = `${a.lastName} ${a.firstName} ${a.middleName} ${a.id}`
                                const bName = `${b.lastName} ${b.firstName} ${b.middleName} ${b.id}`
                                return aName.localeCompare(bName)
                            }).map(renderItem)}
                        </TableBody>
                    }
                </Table>
            </TableContainer>
            {renderTransferStudent()}
            {renderRemoveUserMessage()}
        </div>
    )
}

UsersTable.propTypes = {
    users: PropTypes.array,
}